<template>
  <vs-popup class="create-courier-supplier-popup"
            id="popup"
            title="CREATE COURIER SERVICE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-courier-supplier-popup" @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <v-select  :clearable="false" name="name" placeholder="" v-model="createForm.name" :options="courier_names.filter((x) => x !== option)" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">Nominal Code</small>
              <v-select :clearable="false" name="nominal_code" placeholder=""
                        label="name" v-model="createForm.sage_nominal_code_id" :reduce="option => option.id"
                        :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:FULL w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-input v-model="createForm.description"   name="description" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CourierRepository = RepositoryFactory.get('courier')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  function initialState() {
    return {
      open: false,
      createForm: {},
      countryCodes: [],
      id: '',
      option: [],
      courier_names: ['Pallet', 'Small Pack'],
      sage_nominal_codes:[],
    }
  }

export default {
  name: 'CreateCourierSupplierPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, option) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        this.option = option
        // await this.loadCountrCode()
        await this.getSageNominalCodes()
        this.open = true;
      } catch (error) {
      }
    },

    async loadCountrCode() {
      await this.$vs.loading({
        container: '#create-courier-shipment-popup',
        scale: 0.45
      })
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
      this.$vs.loading.close('#create-courier-shipment-popup > .con-vs-loading')
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
        this.createForm.supplier_id = this.id
         await CourierRepository.createCourierService(this.createForm)
         this.showSuccessMessage('Courier service created successfully')
         await vue.$parent.fetchCourierServiceLIst()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .create-courier-supplier-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }
</style>
